import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  SubTopic,
  CreateSubTopicPayload,
  UpdateSubTopicPayload,
} from "./SubTopic.model";

export function useSubTopicApi() {
  const { api } = useApi();
  const preFix = "platform/sub-topics";

  return useMemo(
    () => ({
      getSubTopics: (topicId: number) =>
        apiResolver<SubTopic[]>(
          api.get(preFix, {
            params: { topicId },
          })
        ),
      createSubTopic: (payload: CreateSubTopicPayload) =>
        apiResolver<SubTopic>(api.post(preFix, payload)),
      updateSubTopic: (subTopicId: string, payload: UpdateSubTopicPayload) =>
        apiResolver<SubTopic>(api.put(`${preFix}/${subTopicId}`, payload)),
      deleteSubTopic: (subTopicId: string) =>
        apiResolver<{ message: string }>(api.delete(`${preFix}/${subTopicId}`)),
    }),
    [api]
  );
}
